<script lang="ts">
  import _ from "lodash"
  import Swot from "./PlanReview/Swot.svelte"
  import {
    strengthIcon,
    weaknessIcon,
    opportunityIcon,
    threatIcon
  } from "$app/utils"
  import GoalsBoxAnnual from "$app/Pages/Plans/OnePageView/GoalsBoxAnnual.svelte"
  import GoalsBoxDept from "$app/Pages/Plans/OnePageView/GoalsBoxDept.svelte"
  import { appStore } from "$app/store.svelte"

  let { dates, headings } = $props()

  const plan = appStore.plan
  const meeting_type = appStore.meeting_type
  const departments = appStore.departments

  const longTermGoals = appStore.goals
    .filter((g) => g.type === "LongTermGoal")
    .sort((a, b) => a.parent_position - b.parent_position)

  const annualGoals = appStore.goals
    .filter((g) => g.type === "AnnualGoal")
    .sort((a, b) => a.assignee_position - b.assignee_position)

  export function valid(): boolean {
    return true
  }
  let strengths = $derived(
    appStore.statements
      .filter((st) => st.section_type === "Strength")
      .sort((a, b) => a.position - b.position)
  )

  let weaknesses = $derived(
    appStore.statements
      .filter((st) => st.section_type === "Weakness")
      .sort((a, b) => a.position - b.position)
  )

  let opportunities = $derived(
    appStore.statements
      .filter((st) => st.section_type === "Opportunity")
      .sort((a, b) => a.position - b.position)
  )

  let threats = $derived(
    appStore.statements
      .filter((st) => st.section_type === "Threat")
      .sort((a, b) => a.position - b.position)
  )

  const options = { fiscal_year: dates.year }
</script>

<h2
  class="text-xl text-center w-full py-4 font-semibold bg-indigo-50 text-indigo-800 rounded-sm shadow px-4"
>
  {#if meeting_type === "quarterly"}
    Review your SWOT and ensure that your upcoming quarterly goals are aligned.
    See if any changes need to be made.
  {:else if meeting_type === "annual"}
    Review your SWOT and ensure that your upcoming annual and quarterly goals
    are aligned. See if any changes need to be made.
  {/if}
</h2>

<div class="w-full mt-2 sticky top-0 bg-lwp-pale-grey z-20">
  <div class="w-full grid grid-cols-2 md:grid-cols-4 gap-4 py-2">
    <div id="swot-strengths">
      <Swot
        statements={strengths}
        title="Strengths"
        sectionType="Strength"
        icon={strengthIcon}
        editable={false}
        height="h-56"
      />
    </div>
    <div id="swot-weaknesses">
      <Swot
        statements={weaknesses}
        title="Weaknesses"
        sectionType="Weakness"
        icon={weaknessIcon}
        editable={false}
        height="h-56"
      />
    </div>
    <div id="swot-opportunities">
      <Swot
        statements={opportunities}
        title="Opportunities"
        sectionType="Opportunity"
        icon={opportunityIcon}
        editable={false}
        height="h-56"
      />
    </div>
    <div id="swot-threats">
      <Swot
        statements={threats}
        title="Threats"
        sectionType="Threat"
        icon={threatIcon}
        editable={false}
        height="h-56"
      />
    </div>
  </div>
</div>

<div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 mt-2" id="goal-boxes">
  {#if meeting_type === "annual"}
    <GoalsBoxAnnual
      {headings}
      {options}
      goals={annualGoals}
      hideCompleted={false}
    />
  {/if}

  {#each departments as department (department.id)}
    <GoalsBoxDept
      {department}
      hideCompleted={false}
      title="{department.name} Goals - {dates.next_quarter}"
      showAddButton={false}
      goals={appStore.goals
        .filter(
          (g) => g.assignee_id === department.id && g.type === "QuarterlyGoal"
        )
        .sort((a, b) => a.assignee_position - b.assignee_position)}
    />
  {/each}
</div>
